<template>
  <app-students :isTeacher="true" />
</template>
<script>
import Students from "./Students";
export default {
  components: {
    appStudents: Students,
  },
};
</script>
